import { useMediaQuery } from './use-media-query';

const MOBILE_QUERY = '(max-width: 1023px)';

/**
 * Returns true when the viewport is below the lg Tailwind breakpoint (< 1024px).
 * Updates reactively whenever the viewport crosses the boundary.
 */
export function useIsMobile(): boolean {
  return useMediaQuery(MOBILE_QUERY);
}
